import {useFormik} from 'formik';
import React, {useState, useEffect, useContext} from 'react';
import * as Yup from 'yup';
import {AppContext} from '../Context';
import {useMediaQuery} from 'react-responsive';
import icoScanner from '../../images/scanner.png';
import TakeImage from '../TakeImage';
import ModalComponent from '../../../common-scripts/Helpers/ModalComponent';
import iconPdfChosed from '../../images/pdfchoosed.png';

/**
 * Step Pièce d'identité
 *
 * @param texteInfos
 * @param userData
 * @param checkReadyForSaving
 * @returns {JSX.Element}
 * @constructor
 */
const StepIdentityCard = ({texteInfos, userData, checkReadyForSaving}) => {

	const {
		currentStep,
		steps,
		setSteps,
		dispatchStepEvent,
		datas,
		setdatas,
		setshowloader,
		setiframeurl,
		iframeurl,
		showloader,
		scrollToTop
	} = useContext(AppContext);

	const initialValues = (userData != undefined || userData != null) ? userData : {
		cardType: '',
		cardVerso: '',
		cardRecto: ''
	}

	const validationSchema = Yup.object({
		cardType: Yup.string().required('Requis'),
		cardVerso: Yup.string().when('cardType', {
			is: 'Carte Nationale d’Identité',
			then: Yup.string().required('Requis'),
			otherwise: Yup.string()
		}),
		cardRecto: Yup.string().required('Requis')
	});

	const isMobile = useMediaQuery({query: '(max-width: 575px)'})

	const formik = useFormik({
		validationSchema: validationSchema,
		initialValues: initialValues
	})

	const [showTakeImage, setshowTakeImage] = useState(false);

	const [triggerImage, setTriggerImage] = useState(null);

	const [{altRecto, srcRecto}, setImgRecto] = useState({
		srcRecto: null,
		altRecto: 'Upload an Image'
	});

	const [{altVerso, srcVerso}, setImgVerso] = useState({
		srcVerso: null,
		altVerso: 'Upload an Image'
	});

	/**
	 * Handle Image
	 *
	 * @param e
	 * @returns {Promise<void>}
	 */
	const handleImg = async (e) => {

		if (e.target.files[0]) {
			const file = e.target.files[0];
			if (e.target.id == "imgRecto") {
				setImgRecto({
					srcRecto: file.type === 'application/pdf' ? iconPdfChosed : URL.createObjectURL(file),
					altRecto: file.name
				})

				const rectoBase64 = await convertToBase64(file);
				formik.setFieldValue('cardRecto', rectoBase64);
				formik.setTouched({...formik.touched, cardRecto: true})
			} else {
				setImgVerso({
					srcVerso: file.type === 'application/pdf' ? iconPdfChosed : URL.createObjectURL(file),
					altVerso: file.name
				});
				const versoBase64 = await convertToBase64(file);
				formik.setFieldValue('cardVerso', versoBase64);
				formik.setTouched({...formik.touched, cardRecto: true})
			}

		}
	}

	/**
	 * Set Image data
	 *
	 * @param data
	 */
	const setImageData = (data) => {
		switch (triggerImage) {
			case "cardVerso":
				setImgVerso({
					srcVerso: data,
					altVerso: "verso"
				});
				formik.setFieldValue('cardVerso', data);
				formik.setTouched({...formik.touched, cardRecto: true})
				break;

			case "cardRecto" :
				setImgRecto({
					srcRecto: data,
					altRecto: "recto"
				});
				formik.setFieldValue('cardRecto', data);
				formik.setTouched({...formik.touched, cardRecto: true})
				break;
		}
		setshowTakeImage(false);


	}

	/**
	 * Convert image data to base64
	 *
	 * @param file
	 * @returns {Promise<unknown>}
	 */
	const convertToBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};
			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	/**
	 * Pick Up Image
	 *
	 * @param e
	 */
	const pickUpImage = (e) => {
		switch (e.target.id) {
			case "btnImgRecto":
				hiddenFileInputRecto.current.click()
				break;
			case "btnImgRectoScanner":
				setTriggerImage("cardRecto")
				setshowTakeImage(true);
				break;
			case  "btnImgVerso":
				hiddenFileInputVerso.current.click();
				break;
			case "btnImgVersoScanner":
				setTriggerImage("cardVerso")
				setshowTakeImage(true);
				break;
		}

	}

	const hiddenFileInputRecto = React.useRef(null);

	const hiddenFileInputVerso = React.useRef(null);

	const [designedTypeCard, setdesignedTypeCard] = useState(initialValues.cardType == '' ? null : initialValues.cardType);

	/**
	 * On Change card type (passeport ou pièce d'identité)
	 *
	 * @param e
	 */
	const onChangeDesignTypeCard = (e) => {

		setdesignedTypeCard(e.target.value);
		formik.setFieldValue('cardType', e.target.value);
		formik.setTouched({...formik.touched, 'cardType': true})

	}

	const electronicSignature = () => {

		dispatchStepEvent('SIGNER', true);
	}

	useEffect(() => {

		valideStepForm();

	}, [formik.values])

	const valideStepForm = () => {
		checkReadyForSaving(Object.keys(formik.touched).length > 0)
		formik.validateForm().then((res) => {
			datas[currentStep] = formik.values;
			setdatas(datas);
			if (Object.keys(res).length == 0) {
				dispatchStepEvent('SET_STEP_READY', true);
			} else {
				dispatchStepEvent('SET_STEP_READY', false)
			}
		})
	}

	return <>


		<div id="step-3" className="step-form">

			<div className="card-banner info" dangerouslySetInnerHTML={{__html: texteInfos}}>

			</div>

			<div className="form-card">
				<div className="card-header">
					Sélectionner votre pièce d’identité
				</div>
				<div className="card-body">

					<div className="form-group block ">


						<div role="group" className="btn-group btn-group-radio-column btn-group-radio">
							<label className="bouton-form-radio">
								<input readOnly={true} defaultValue={'Carte Nationale d’Identité'}
									   checked={designedTypeCard === "Carte Nationale d’Identité"}
									   onChange={onChangeDesignTypeCard} className="" name="cardType" type="radio"
									   title="Sélectionner votre pièce d’identité"/>
								Carte Nationale d’Identité
							</label>

							<label className="bouton-form-radio">
								<input readOnly={true} defaultValue={'Passeport'}
									   checked={designedTypeCard === "Passeport"}
									   onChange={onChangeDesignTypeCard}
									   className=""
									   name="cardType" type="radio" title="Sélectionner votre pièce d’identité"/>
								Passeport
							</label>

						</div>

					</div>

					<input hidden={true} onChange={formik.handleChange} value={formik.values.cardType} name="cardType"
						   id="cardType"/>


				</div>
			</div>

			<div className="form-card">
				<div className="card-header">
					Recto
				</div>
				<div className="card-body">
					<div className="form-group block ">
						<input
							type="file"
							accept=".png, .jpg, .jpeg, .pdf"
							id="imgRecto"
							ref={hiddenFileInputRecto}
							hidden={true}
							onChange={handleImg}
						/>

						<div className="form-image-preview">

							{srcRecto && <img src={srcRecto} alt={altRecto}/>}
							<input hidden={true} onChange={formik.handleChange} value={formik.values.cardRecto}
								   name="cardRecto" id="cardRecto"/>

						</div>

						<p>Sélectionnez votre choix :</p>

						<div className="bottom">

							<div className="prev_next stepper">
								<button style={{marginRight: '0px'}} id="btnImgRecto" onClick={pickUpImage}
										className="bouton-picto-left goto_backto ready"><i
									className="fa fa-download"></i>{isMobile ? 'Télécharger à partir de mon appareil' : 'Télécharger à partir de mes dossiers'}
								</button>

							</div>
						</div>


					</div>

				</div>
			</div>
			{designedTypeCard === "Carte Nationale d’Identité" && <div className="form-card">
				<div className="card-header">
					Verso
				</div>
				<div className="card-body">
					<div className="form-group block ">
						<input
							type="file"
							accept=".png, .jpg, .jpeg, .pdf"
							id="imgVerso"
							ref={hiddenFileInputVerso}
							hidden={true}
							onChange={handleImg}
						/>

						<div className="form-image-preview">

							{srcVerso && <img src={srcVerso} alt={altVerso}/>}
							<input hidden={true} onChange={formik.handleChange} value={formik.values.cardVerso}
								   name="cardVerso" id="cardVerso"/>
						</div>

						<p>Sélectionnez votre choix :</p>

						<div className="bottom">

							<div className="prev_next stepper">
								<button style={{marginRight: '0px'}} id="btnImgVerso" onClick={pickUpImage}
										className="bouton-picto-left goto_backto ready"><i
									className="fa fa-download"></i>{isMobile ? 'Télécharger à partir de mon appareil' : 'Télécharger à partir de mes dossiers'}
								</button>
							</div>
						</div>


					</div>

				</div>
			</div>}
			<div className="bottom">

				<div className="prev_next stepper">

					<div>
						<button onClick={electronicSignature}
								className={`bouton bouton-full bouton-business bouton-picto-r goto_backto ${!steps[currentStep].is_ready_for_next ? "wait" : "ready"}`}>
							<span>Signer </span> <i className="fun-picto fun-picto-arrow-right"></i></button>
					</div>

				</div>
			</div>
			{showTakeImage &&
				<ModalComponent showModal={true} content={<TakeImage onImageDataChange={setImageData}/>}/>}

		</div>


	</>
}

export default StepIdentityCard
